import type {
	MessageToolCodeBasedTableAnalysisData,
	MessageToolCodeBasedTableAnalysisDocument,
} from "@virtual-brain-lib/types";

import { ToolCard } from "../core";
import { CodeBasedTableAnalysisDocumentRow } from "./CodeBasedTableAnalysisDocumentRow";

export function ToolCardCodeBasedTableAnalysis({
	state,
	onDocumentClick,
	className,
}: {
	readonly state: MessageToolCodeBasedTableAnalysisData;
	readonly onDocumentClick?: (doc: MessageToolCodeBasedTableAnalysisDocument) => void;
	readonly className?: string;
}) {
	const { status, statusText, documents } = state;
	const displayedStatusText = statusText ?? defaultStatusText(state);

	if (documents.length === 0) {
		return null;
	}

	return (
		<ToolCard
			className={className}
			icon="terminal"
			status={status}
			statusText={displayedStatusText}
			title="Table Analysis"
		>
			<div className="flex flex-col gap-2.5">
				{documents.map((document) => (
					<CodeBasedTableAnalysisDocumentRow
						key={document.id}
						document={document}
						onDocumentClick={onDocumentClick}
					/>
				))}
			</div>
		</ToolCard>
	);
}

function defaultStatusText({ status, documents }: MessageToolCodeBasedTableAnalysisData): string {
	if (status === "processing") {
		return "Running code-based analysis";
	}

	const count = documents.length;

	if (count === 0) {
		return "No document analyzed";
	}

	return `Analyzed ${count} document${count > 1 ? "s" : ""}`;
}
